import {
  useGridApiContext,
  useGridSelector,
  gridDensitySelector,
} from "@mui/x-data-grid-premium";
import { standardizeAndMagnifyEffectHtmlImages } from "./htmlColumn";

export const HtmlCell = ({
  value,
  containerStyle,
}: {
  value: any;
  containerStyle?: React.CSSProperties;
}) => {
  const apiRef = useGridApiContext();
  const density = useGridSelector(apiRef, gridDensitySelector);
  return (
    <div
      onMouseDown={(e) => e.stopPropagation()}
      style={{
        height: "100%",
        width: "100%",
        ...containerStyle,
      }}
      dangerouslySetInnerHTML={{
        __html: standardizeAndMagnifyEffectHtmlImages(value, density),
      }}
    />
  );
};
